/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Select } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { getCtCookie, languages, updateCTCookie } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { changeUserLanguage, userAuthenticatedState } from 'src/features'
import { CustomCol, FormLabels, LanguageSelectorOption } from 'src/components'

const UserPreferenceChangeLanguage: React.FC = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const user = useAppSelector(userAuthenticatedState)
  const [language, setLanguage] = useState(null)
  const languageCookie = getCtCookie('ct-language')

  const handleChangeLanguage = (language: string) => {
    // Update Language
    setLanguage(language)
    dispatch(changeUserLanguage({ language }))
    updateCTCookie('ct-language', language)
  }

  useEffect(() => {
    if (user?.language) {
      setLanguage(user.language)
      i18n.changeLanguage(language)
      router.push(router.asPath, undefined, { locale: language })
    }
  }, [user])

  useEffect(() => {
    if (languageCookie) {setLanguage(languageCookie?.toLowerCase())}
  }, [languageCookie])

  return (
    <Row>
      <CustomCol>
        <FormLabels
          title={t('settings.Language')}
          subtitle={t('settings.ChoseLanguage')}
        />
      </CustomCol>
      <CustomCol>
        <Select
          size='large'
          showSearch={false}
          style={{ width: '100%' }}
          value={language}
          onChange={handleChangeLanguage}
        >
          {languages.map((item, idx) => (
            <Select.Option value={item.value} key={idx}>
              <LanguageSelectorOption item={item} />
            </Select.Option>
          ))}
        </Select>
      </CustomCol>
    </Row>
  )
}

export default UserPreferenceChangeLanguage
